import React, { Fragment, useContext } from 'react'
import { FaShoppingBag, FaWallet } from 'react-icons/fa'
import { FaLocationDot } from "react-icons/fa6";
import { IoTimeSharp } from "react-icons/io5";
import CommonContext from '../../hooks/CommonContext';
import { MdDeleteOutline } from "react-icons/md";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";

const JobCard = ({ handleRemoveJob, companyName, cardImage, cardName, cardId, cardDes, cardType, applicationStatus, cardHeading, cardPostedOn, cardWorkplace, jobStatus, cardSchedule, cardJobType, cardPayment, unsavedJobId }) => {

  const {
    handleSelectedCardData,
    setIsSelectedJob
  } = useContext(CommonContext);

  function handleAppliedState(jobStatus, appliStatus) {
    switch (jobStatus) {
      case "Closed":
        return <Fragment>
          <div className='d-inline-flex appliedOrSaved'>
            <div className={`py-1 px-3 me-1 ${applicationStatus === "Not Reviewed" ? 'job-reviewed' : null ||
              applicationStatus === "Shortlisted" ? 'job-shortlisted' : null ||
                applicationStatus === "Contacted" ? 'job-contacted' : null ||
                  applicationStatus === "Rejected" ? 'job-rejected' : null ||
                    applicationStatus === "Hired" ? 'job-shortlisted' : null
              }`
            }>

              <p className='m-0'>{applicationStatus === "Not Reviewed" ? 'Not Reviewed' : null ||
                applicationStatus === "Shortlisted" ? 'Shortlisted' : null ||
                  applicationStatus === "Contacted" ? 'Invited' : null ||
                    applicationStatus === "Rejected" ? 'Not selected by Employer' : null ||
                      applicationStatus === "Hired" ? 'Hired' : null
              }</p>
            </div>

            <div className={'py-1 px-3 appliedOrSaved-borderRadius job-rejected'}>
              <p className='m-0'>{jobStatus === "Closed" ? "This job has been closed" : null}
              </p>
            </div>
          </div>
        </Fragment>


      case "paused":
        return <Fragment>
          <div className='flex-shrink-0 appliedOrSaved'>
            <div
              className={`py-1 px-3 appliedOrSaved-borderRadius
                  ${applicationStatus === "Not Reviewed" ? 'job-reviewed' : null ||
                  applicationStatus === "Shortlisted" ? 'job-shortlisted' : null ||
                    applicationStatus === "Contacted" ? 'job-contacted' : null ||
                      applicationStatus === "Rejected" ? 'job-rejected' : null ||
                        applicationStatus === "Hired" ? 'job-shortlisted' : null
                }`
              }>

              <p className='m-0'>{applicationStatus === "Not Reviewed" ? 'Not Reviewed' : null ||
                applicationStatus === "Shortlisted" ? 'Shortlisted' : null ||
                  applicationStatus === "Contacted" ? 'Invited' : null ||
                    applicationStatus === "Rejected" ? 'Not selected by Employer' : null ||
                      applicationStatus === "Hired" ? 'Hired' : null
              }</p>
            </div>
          </div>
        </Fragment>

      default:
        break;
    }
  }

  return (
    <div className='cursorPointer'>
      <div className={`d-flex my-2 mt-3 ${applicationStatus === "1Y" && (jobStatus === "Closed" || jobStatus === "paused" || jobStatus === "Paused") ? "pt-4 align-items-end" : "align-items-center"}`}>
        <div className="flex-shrink-0" onClick={() => {
          setIsSelectedJob(true)
          handleSelectedCardData(cardId)
        }}>
          <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${cardImage}`} alt="..." width={52} height={52} className='pe-none rounded-circle objectContain' />
        </div>
        <div className="flex-grow-1 ms-3" onClick={() => {
          setIsSelectedJob(true)
          handleSelectedCardData(cardId)
        }}>
          <h6 className='job-card-component-heading text-break'>{cardHeading}</h6>
          <p className='job-card-posted-time m-0 text-secondary'><HiOutlineBuildingOffice2 className='fs-5 me-2' />{companyName}<span className='px-2'>|</span> Posted on {cardPostedOn}</p>
        </div>

        {/* All job cards  */}
        {
          cardType === "all" ?
            applicationStatus === "1Y" ?
              <div className='flex-shrink-0 appliedOrSaved'>
                <div
                  className={`py-1 px-3 appliedOrSaved-borderRadius job-reviewed`}>

                  <p className='m-0'>Invite to Apply by Employer</p>
                </div>
              </div>
              :
              null
            :
            null
        }

        {/* saved job cards  */}
        {
          cardType === "saved" ?
            jobStatus === "Closed" || jobStatus === "paused" || jobStatus === "Paused" ?
              <Fragment>
                <div className='flex-shrink-0 appliedOrSaved'>
                  <div
                    className={'py-1 px-3 appliedOrSaved-borderRadius job-rejected'}>

                    <p className='m-0'>{
                      jobStatus === "Closed" ? "This job has been closed" : null ||
                        (jobStatus === "paused" || jobStatus === "Paused") ? "This job is no longer receiving applicants" : null
                    }
                    </p>
                  </div>
                </div>

                {
                  applicationStatus === "1Y" ?
                    <div className='flex-shrink-0 saved_invited_by_emp'>
                      <div
                        className={`py-1 px-3 job-reviewed`}>

                        <p className='m-0'>Invite to Apply by Employer</p>
                      </div>
                    </div>
                    :
                    null
                }
              </Fragment>
              :
              applicationStatus === "1Y" ?
                <div className='flex-shrink-0 appliedOrSaved'>
                  <div
                    className={`py-1 px-3 appliedOrSaved-borderRadius job-reviewed`}>

                    <p className='m-0'>Invite to Apply by Employer</p>
                  </div>
                </div>
                :
                null

            :
            null
        }

        {/* Applied job cards  */}
        {
          cardType === "applied" ?
            jobStatus === "Closed" || jobStatus === "paused" || jobStatus === "Paused" ?
              handleAppliedState(jobStatus, applicationStatus)
              :
              <div className='flex-shrink-0 appliedOrSaved'>
                <div
                  className={`py-1 px-3 appliedOrSaved-borderRadius
                  ${applicationStatus === "Not Reviewed" ? 'job-reviewed' : null ||
                      applicationStatus === "Shortlisted" ? 'job-shortlisted' : null ||
                        applicationStatus === "Contacted" ? 'job-contacted' : null ||
                          applicationStatus === "Rejected" ? 'job-rejected' : null ||
                            applicationStatus === "Hired" ? 'job-shortlisted' : null
                    }`
                  }>

                  <p className='m-0'>{applicationStatus === "Not Reviewed" ? 'Not Reviewed' : null ||
                    applicationStatus === "Shortlisted" ? 'Shortlisted' : null ||
                      applicationStatus === "Contacted" ? 'Invited' : null ||
                        applicationStatus === "Rejected" ? 'Not selected by Employer' : null ||
                          applicationStatus === "Hired" ? 'Hired' : null
                  }</p>
                </div>
              </div>
            :
            null
        }


        {/* recommended job cards  */}
        {
          cardType === "recommended" ?
            <div className='flex-shrink-0 appliedOrSaved'>
              <div
                className={`py-1 px-3 appliedOrSaved-borderRadius
                ${applicationStatus === "AI Recommendation" ? 'job-reviewed' : null ||
                    applicationStatus === "2nd Career Recommendation" ? 'job-shortlisted' : null
                  }`
                }
              >

                <p className='m-0'>{applicationStatus === "2nd Career Recommendation" ? "2nd Careers Recommendation" : null ||
                  applicationStatus === "AI Recommendation" ? 'AI Recommendation' : null
                }</p>
              </div>
            </div>
            :
            null
        }

        {
          cardName === "saved" ?
            unsavedJobId === cardId ?
              <button type="button" className="btn btn-outline-secondary d-flex align-items-center pe-none" onClick={() => handleRemoveJob(cardId)}>
                <div className="spinner-border remove-spinner-width" role="status"></div>
                <span className='ps-2 d-none d-md-inline'>Removing</span>
              </button>
              :
              <button type="button" className="btn btn-outline-secondary d-flex align-items-center" onClick={() => handleRemoveJob(cardId)}>
                <MdDeleteOutline className='fs-5' /> Remove
              </button>
            :
            null
        }


      </div>
      <div onClick={() => {
        handleSelectedCardData(cardId)
        setIsSelectedJob(true)
      }}>
        <div className="row justify-content-around card-company-details-icon mt-4">
          <label className="fs-7 card-inner-details col-6 col-sm-3 px-4 px-sm-0 py-1 py-sm-0 text-start text-sm-center">
            <FaLocationDot className="me-2 text-success" />
            {cardWorkplace}

          </label>
          <label className="fs-7 card-inner-details col-6 col-sm-3 px-4 px-sm-0 py-1 py-sm-0 text-start text-sm-center">
            <FaShoppingBag className="me-2 text-warning" />
            {cardSchedule}
          </label>
          <label className="fs-7 card-inner-details col-6 col-sm-3 px-4 px-sm-0 py-1 py-sm-0 text-start text-sm-center">
            <IoTimeSharp className="me-2 text-primary" />
            {cardJobType}
          </label>
          <label className="fs-7 card-inner-details col-6 col-sm-3 px-4 px-sm-0 py-1 py-sm-0 text-start text-sm-center">
            <FaWallet className="me-2 text-warning" />
            {cardPayment}
          </label>
        </div>
        <p className='mt-4 job-card-description'>{cardDes}</p>
      </div>
    </div>
  )
}

export default JobCard